/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LogoIcon = ({ width = 24, height = 24, hidden = false, title = 'Logo' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.25,12.75h-5.5c-.26465,0-.50977-.13965-.64502-.36719s-.14014-.50977-.01318-.74219l2.75098-5.03906c.13135-.24121.38379-.39062.6582-.39062h0c.27441,0,.52686.15039.6582.39062l2.74902,5.03906c.12695.23242.12207.51465-.01318.74219s-.38037.36719-.64502.36719ZM10.01416,11.25h2.97217l-1.48535-2.72363-1.48682,2.72363Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M5.74951,12.75c-.12158,0-.24463-.0293-.35889-.0918-.36377-.19824-.49756-.6543-.29883-1.01758l1.98145-3.62891c.19873-.36328.6543-.49805,1.01758-.29883.36377.19824.49756.6543.29883,1.01758l-1.98145,3.62891c-.13623.24902-.39355.39062-.65869.39062Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M10,18.75c-.11523,0-.23047-.02637-.33594-.0791l-7.73096-3.875c-.25391-.12793-.41406-.38672-.41406-.6709V5.875c0-.28418.16016-.54297.41406-.6709l7.73096-3.875c.21094-.10547.46094-.10547.67188,0l7.73096,3.875c.25391.12793.41406.38672.41406.6709v8.25c0,.28418-.16016.54297-.41406.6709l-7.73096,3.875c-.10547.05273-.2207.0791-.33594.0791ZM3.01904,13.66211l6.98096,3.49902,6.98096-3.49902v-7.32422l-6.98096-3.49902-6.98096,3.49902v7.32422Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
